import { render } from "./App.vue?vue&type=template&id=fa973a80"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=fa973a80&lang=css"

import exportComponent from "C:\\MyFile\\codeVue\\xb-notes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__